<template>
  <div class="box-container max-w-4xl">
    <d-card
      clipped
      class="mb-5"
    >
      <table class="table is-wide w-full">
        <tr>
          <td class="has-text-weight-bold">
            <span class="has-text-weight-bold">
              {{ $t("email").capitalize() }}
            </span>
          </td>
          <td>
            <a :href="`mailto:${model.email}`">{{ model.email }}</a>
          </td>
        </tr>
        <tr>
          <td>
            <span class="has-text-weight-bold">
              {{ $t("phone").capitalize() }}
            </span>
          </td>
          <td>
            <a :href="`tel:${model.phone}`">{{ model.phone }}</a>
          </td>
        </tr>
        <tr>
          <td>
            <span class="has-text-weight-bold">
              {{ $t("tenant_insurance").capitalize() }}
            </span>
          </td>
          <td>
            <d-bool-icon
              :true-value="true"
              :false-value="false"
              :value="model.tenant_insurance"
            >
              {{ $t("tenant_insurance").capitalize() }}
            </d-bool-icon>
          </td>
        </tr>

        <tr>
          <td>
            <span class="has-text-weight-bold">
              {{ $t("payment_method").capitalize() }}
            </span>
          </td>
          <td>
            {{ model.payment_method }}
          </td>
        </tr>

        <tr>
          <td>
            <span class="has-text-weight-bold">
              {{ $t("possible_lease_duration").capitalize() }}
            </span>
          </td>
          <td class="content">
            <ul
              v-if="model.possible_lease_duration && model.possible_lease_duration.length"
              class="ml-4 mt-0"
            >
              <li
                v-for="(item,key) in model.possible_lease_duration"
                :key="key"
              >
                <p v-if="item.key == $laravel.owner_lease_duration_other">
                  {{ $t('other') }}: ({{ model.possible_lease_duration_other }})
                </p>
                <p v-if="item.key != $laravel.owner_lease_duration_other">
                  {{ $t(item.key) }}
                </p>
              </li>
            </ul>
            <span v-else> - </span>
          </td>
        </tr>

        <tr>
          <td style="border-bottom: none;">
            <span class="has-text-weight-bold">
              {{ $t("important_information_for_lease_writing").capitalize() }}
            </span>
          </td>
          <td style="border-bottom: none;">
            <div v-html="model.important_information_for_lease_writing" />
          </td>
        </tr>
      </table>
    </d-card>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
};
</script>
